'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  padding: 10px;\n  background: ', ';\n  color: ', ';\n  display: flex;\n  height: 60px;\n  border-radius: 30px;\n  align-items: center;\n'], ['\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  padding: 10px;\n  background: ', ';\n  color: ', ';\n  display: flex;\n  height: 60px;\n  border-radius: 30px;\n  align-items: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-right: 10px;\n'], ['\n  margin-right: 10px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n'], ['\n  width: 100%;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  font-weight: 700;\n  margin-top: 5px;\n'], ['\n  width: 100%;\n  font-weight: 700;\n  margin-top: 5px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100px;\n  text-align: left;\n  font-weight: 700;\n  font-size: 18px;\n'], ['\n  width: 100px;\n  text-align: left;\n  font-weight: 700;\n  font-size: 18px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Avatar = require('../../Avatar/Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Color
// Helper components


var Container = _styledComponents2.default.div(_templateObject, _colors.black, _colors.white);

var AvatarContainer = _styledComponents2.default.div(_templateObject2);

var Content = _styledComponents2.default.div(_templateObject2);

var Name = _styledComponents2.default.div(_templateObject3);

var Svid = _styledComponents2.default.div(_templateObject4);

var Speed = _styledComponents2.default.div(_templateObject5);

var SelectedVehicle = function (_Component) {
  _inherits(SelectedVehicle, _Component);

  function SelectedVehicle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectedVehicle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectedVehicle.__proto__ || Object.getPrototypeOf(SelectedVehicle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false
    }, _this.onHover = function () {
      return _this.setState({
        hover: true
      });
    }, _this.onBlur = function () {
      return _this.setState({
        hover: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectedVehicle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          moving = _props.moving,
          svid = _props.svid,
          driver = _props.driver,
          marker = _props.marker,
          speed = _props.speed,
          onClose = _props.onClose;
      var hover = this.state.hover;
      return _react2.default.createElement(Container, {
        onMouseEnter: this.onHover,
        onMouseLeave: this.onBlur
      }, _react2.default.createElement(AvatarContainer, null, hover ? _react2.default.createElement(_Button2.default, {
        icon: 'close',
        size: 'large',
        theme: moving ? 'red' : 'grey',
        onClick: onClose
      }) : _react2.default.createElement(_Avatar2.default, {
        avatar: marker,
        size: 'large',
        theme: moving ? 'red' : 'grey'
      })), _react2.default.createElement(Content, null, _react2.default.createElement(Name, null, driver), _react2.default.createElement(Svid, null, svid)), moving && _react2.default.createElement(Speed, null, _react2.default.createElement(_Icon2.default, {
        icon: 'dashboard'
      }), ' ', speed, ' mph'));
    }
  }]);

  return SelectedVehicle;
}(_react.Component);

SelectedVehicle.propTypes = {
  moving: _propTypes2.default.bool,
  svid: _propTypes2.default.string,
  driver: _propTypes2.default.string,
  marker: _propTypes2.default.string,
  speed: _propTypes2.default.number,
  onClose: _propTypes2.default.func
};
exports.default = SelectedVehicle;